// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-7584a85e]{max-width:500px;display:block;margin:40px auto}", ""]);
// Exports
module.exports = exports;
